import { Skeleton } from "@/components/ui/skeleton";

/**
 * What a list looks like while it loads.
 *
 * A skeleton shaped like the table that is coming, not a spinner. A spinner
 * says "something is happening"; a skeleton says what is about to appear and
 * stops the layout jumping when it does.
 */
export function TableSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div className="divide-border divide-y" aria-hidden>
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="flex items-center gap-4 px-6 py-3">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-20" />
          <Skeleton className="ml-auto h-4 w-16" />
        </div>
      ))}
    </div>
  );
}

/**
 * The whole page, while the route resolves.
 *
 * Announced politely rather than silently: a screen reader gets "Loading"
 * once, not a stream of skeleton divs.
 */
export function PageSkeleton() {
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col" aria-busy="true">
      <span className="sr-only" role="status">
        Loading
      </span>
      <div className="flex shrink-0 items-center justify-between gap-4 border-b px-6 py-3">
        <div className="space-y-2">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-3.5 w-24" />
        </div>
        <Skeleton className="h-8 w-20" />
      </div>
      <div className="flex shrink-0 items-center gap-2 border-b px-6 py-2">
        <Skeleton className="h-8 w-56" />
        <Skeleton className="h-8 w-28" />
        <Skeleton className="h-8 w-20" />
        <Skeleton className="h-8 w-24" />
      </div>
      <TableSkeleton />
    </div>
  );
}
